module.exports = __webpack_public_path__ + "static/media/alerta.b860708b.svg";